export default __webpack_public_path__ + "static/media/bg-menu.ec0738d4.png";